import React, { useState } from 'react';
import { MdLockOutline } from "react-icons/md";
import { Form, FloatingLabel } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { login, setCurrentUser } from '../../actions/users';
import { isEmpty } from '../../actions/commonFunction';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import { toast } from "react-toastify";
import Logo from "../../assets/img/logo.png";

const initialFormValue = {
    'email': '',
    'password': '',
}

const Login = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const Wallet_Details = useSelector((state) => state.wallet_connect_context);

    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [passwordType, setPasswordType] = useState('password')

    
    
    const {
        email,
        password,
    } = formValue

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        let formData = { ...formValue, ...{ [name]: value } }
        setFormValue(formData)
    }

    const handleFormSubmit = async (e) => {
        
        let reqData = {
            email,
            password,
        }
        let {  error, result, token } = await login(reqData);
       
        if (isEmpty(error)) {
            setValidateError({})
            setFormValue(initialFormValue)
            dispatch(setCurrentUser({...result,token,logincheck: 'true'}));
            toast.success("Login successfully");
            navigate('/user')
            
        } else {
            setValidateError(error);
        }
      }


    return (
        <section className="login">
            {/* <div className="login_divone"></div> */}
            <div className="login_divtwo">
                <div className="loginbox">
                    <div className="loginbox_top text-center pb-3">
                        {/* <div className="lockbox">
                            <MdLockOutline />
                        </div> */}
                        {/* <p className="login_head text-center">Sign in</p> */}
                          <img src={Logo} alt="Edaface" className="img-fluid logo" />
                    </div>
                    <div className="loginbox_body">
                        <FloatingLabel label="Email Address" controlId="floatingInput" className="mb-3">
                            <Form.Control type="text" placeholder="Email Address" value={login.email} name="email" onChange={handleChange} />
                            {
                                validateError.email && <span className='error_txt'>{validateError.email}</span>
                            }
                        </FloatingLabel>
                        <FloatingLabel label="Password" controlId="floatingInput">
                            {/* <div> */}
                            <Form.Control type={passwordType} placeholder="Password" value={login.password} name="password" onChange={handleChange} />
                            {
                                passwordType == 'text'
                                ?
                                <IoEye onClick={()=>setPasswordType('password')} className='eyeicons'/>
                                :
                                <IoEyeOff onClick={()=>setPasswordType('text')} className='eyeicons'/>
                            }
                            {/* </div> */}
                            {
                                validateError.password && <span className={'error_txt'}>{validateError.password}</span>
                            }
                        </FloatingLabel>
                        <button type="button" className="btn sitebtn w-100 mt-4" onClick={()=>handleFormSubmit()}>Sign in</button>
                        <p className="t-grey mt-4 text-center">Copyright © EdaFace 2025.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Login;